import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Dialog from 'react-toolbox/lib/dialog'
import { Flex } from 'reflexbox'

import ProgressBar from 'components/fulcrum/progressBar/FulcrumCircularProgressBar'

class AsyncDialog extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    loading: PropTypes.bool.isRequired
  }

  static defaultProps = {
    title: 'Loading in Progress',
    loading: true,
  }

  render() {
    const { loading, title } = this.props

    return (
      <Dialog active={loading} title={title}>
        <Flex justify='center' align='center'>
          <ProgressBar/>
        </Flex>
      </Dialog>
    )
  }
}

export default AsyncDialog
